import { cn } from "@/lib/utils";
import { useTran } from "@/hooks";
import AppDialog from "@/components/common/AppDialog";
import { ChevronLeft, Globe, ChevronRight, Sun, Moon } from "lucide-react";
import { Button } from "@/components/ui/button";
import PreviewQuestionField from "./PreviewQuestionField";

const QuestionPreviewModal = ({ open, onClose, question }) => {
  if (!question) return null;
  const { t } = useTran();
  const text = question.questionText || "Untitled Question";

  return (
    <AppDialog
      open={open}
      onOpenChange={(o) => {
        if (!o) onClose();
      }}
      title={t("Question Preview")}
      size="lg"
    >
      {/* Card Header */}
      <div
        className={cn(
          "flex items-center justify-between px-6 py-4 border-b",
          "border-gray-200 dark:border-white/10",
        )}
      >
        <span className="font-bold tracking-wide text-sm text-emerald-600 dark:text-emerald-400">
          NXSTART
        </span>
        <div className="flex items-center gap-3 text-xs text-gray-500 dark:text-gray-400">
          <span className="flex items-center gap-1">
            <Globe className="h-3.5 w-3.5" /> English
          </span>
          {/* Reflects actual system theme */}
          <Sun className="h-3.5 w-3.5 dark:hidden" />
          <Moon className="h-3.5 w-3.5 hidden dark:block" />
        </div>
      </div>

      {/* Progress Bar */}
      <div className="px-6 pt-4 pb-2">
        <div className="flex items-center justify-between mb-1.5">
          <span className="text-xs font-medium text-gray-600 dark:text-gray-300">
            Survey Preview
          </span>
          <span className="text-xs text-gray-500 dark:text-gray-400">
            1 of 1 (100%)
          </span>
        </div>
        <div className="h-1 w-full rounded-full overflow-hidden bg-gray-200 dark:bg-gray-700">
          <div className="h-full w-full rounded-full bg-emerald-500" />
        </div>
      </div>

      {/* Question Body */}
      <div className="px-6 py-6 space-y-4 min-h-[220px]">
        <p className="text-base leading-snug dark:text-white">{text}</p>
        <PreviewQuestionField question={question} />
      </div>

      {/* Navigation Footer */}
      <div
        className={cn(
          "flex items-center justify-between px-6 py-4 border-t",
          "border-gray-200 dark:border-white/10",
        )}
      >
        <Button>
          <ChevronLeft className="h-4 w-4" /> Previous
        </Button>
        <Button>
          Next <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </AppDialog>
  );
};

export default QuestionPreviewModal;
